var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "16px",
    viewBox: "0 0 12 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "54B9AB77-1CBC-452D-ACAF-7C25F9221C7B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CMS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Other-pages",
    transform: "translate(-542.000000, -236.000000)",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(502.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(34.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vector",
    transform: "translate(7.000000, 44.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.167,4.000122 L0.833,4.000122 C0.37294682,4.000122 0,4.37306882 0,4.833122 L0,11.500122 C0,12.880834 1.1192881,14.000122 2.5,14.000122 L7.5,14.000122 C8.1630415,14.000122 8.798926,13.7367297 9.267767,13.267889 C9.7366077,12.799048 10,12.1631635 10,11.500122 L10,4.833122 C10,4.37306882 9.627053,4.000122 9.167,4.000122 Z",
    id: "Vector-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,2.0000842 L7.89400016,1.78908412 C7.3459004,0.692632099 6.225314,0 4.99950002,0 C3.77368598,0 2.65309946,0.692632099 2.105,1.78908412 L2,2.0000842 L8,2.0000842 Z",
    id: "Vector-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.333,7.3331221 L3.333,10.6661221 M6.667,7.3331221 L6.667,10.6661221 M8,2.0001221 L10,2.0001221 M2,2.0001221 L0,2.0001221",
    id: "Vector-6"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/Trash.7dd8b5704ad54c13ba3ab8c39c9fbf7d.svg";
export { ForwardRef as ReactComponent };